<template>
  <div>
    <b-row>
      <b-col cols="12" md="12" class="text-justify mb-3">
        <strong
          class="fs_16"
          v-text="$lang.final_report_votes_page_jobs_title"
        />
        <p
          class="lh_30 text-muted ml-3"
          v-text="pathOr('', ['biography'], personData)"
        />
      </b-col>
      <b-col cols="12" md="12" class="mb-3">
        <Search
          :title="$lang.final_report_votes_jobs_title"
          :url="jobsUrl"
          :allowFields="$lang.final_report_votes_jobs_fields"
          :visibleAdd="false"
          :allowOperate="false"
          :showFilterBtn="false"
          :visibleSettings="false"
          :visibleExport="false"
          :dataNotExist="$lang.notRecordExist"
        />
      </b-col>
      <b-col cols="12" md="12" class="mb-3">
        <Search
          :title="$lang.cultural_social"
          :url="socialUrl"
          :allowFields="$lang.final_report_votes_social_fields"
          :visibleAdd="false"
          :allowOperate="false"
          :showFilterBtn="false"
          :visibleSettings="false"
          :visibleExport="false"
          :dataNotExist="$lang.notRecordExist"
        />
      </b-col>
      <b-col cols="12" md="12" class="mb-3">
        <Search
          :title="$lang.partner"
          :url="partnerUrl"
          :allowFields="$lang.final_report_partner_fildes"
          :visibleAdd="false"
          :allowOperate="false"
          :showFilterBtn="false"
          :visibleSettings="false"
          :visibleExport="false"
          :dataNotExist="$lang.notRecordExist"
        />
      </b-col>
      <b-col cols="12" md="12" class="text-justify mb-3">
        <div v-if="pathOr(null, ['favorites'], personData)">
          <strong class="fs_16" v-text="$lang.favoritesAndActivity" />
          <p
            class="lh_30 text-muted ml-3"
            v-text="pathOr('', ['favorites'], personData)"
          />
        </div>
        <div v-if="pathOr(null, ['final_introduction'], personData)">
          <strong class="fs_16" v-text="$lang.otherDescription" />
          <p
            class="lh_30 text-muted ml-3"
            v-text="pathOr('', ['final_introduction'], personData)"
          />
        </div>
        <div v-if="pathOr(null, ['conviction_history'], personData)">
          <strong class="fs_16" v-text="$lang.judicialFile" />
          <p
            class="lh_30 text-muted ml-3"
            v-text="pathOr('', ['conviction_history'], personData)"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { pathOr } from "ramda";
import Search from "@/components/base/search";

export default {
  components: {
    Search,
  },
  props: {
    personCode: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      code: this.$route.params.code,
      personData: {},
    };
  },
  computed: {
    jobsUrl() {
      // check requirement
      if (!this.personCode) {
        return null;
      }

      return (
        this.$config.api_url +
        this.$config.profile.person_job_experience.replace(
          "{0}",
          this.personCode
        )
      );
    },
    socialUrl() {
      // check requirement
      if (!this.personCode) {
        return null;
      }

      return (
        this.$config.api_url +
        this.$config.profile.person_social.replace("{0}", this.personCode)
      );
    },
    partnerUrl() {
      // check requirement
      if (!this.personCode) {
        return null;
      }

      return (
        this.$config.api_url +
        this.$config.profile.person_wife_relation.replace(
          "{0}",
          this.personCode
        )
      );
    },
  },
  created() {
    this.getPersonData();
  },
  methods: {
    pathOr,
    async getPersonData() {
      // check requirement
      if (!this.personCode) {
        return false;
      }

      const url = `${this.$config.api_url}${this.$config.resources.person}/${this.personCode}`;
      try {
        const response = await this.$httpService.get(url);
        this.personData = { ...pathOr(null, ["data", "data"], response) };
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
};
</script>